import {HamburgerMenuCloseIcon, HamburgerMenuIcon} from '@prtimes-basis/icons';
import type {ComponentProps} from 'react';
import type {ResponsiveHeader} from '..';
import styles from './hamburger-menu.module.css';
import {ViewStyle} from './view-style';
import {DrawerMenu} from './drawer-menu';
import {type PrtimesInformation} from './drawer-menu/prtimes-information-section';

type Props = {
  readonly view: 'default' | 'search' | 'navi';
  readonly setView: (value: 'default' | 'search' | 'navi') => void;
  readonly informationList?: PrtimesInformation[];
} & Pick<ComponentProps<typeof ResponsiveHeader>, 'viewStyle' | 'setViewStyle'>;

export function HamburgerMenu({
  view,
  setView,
  viewStyle,
  setViewStyle,
  informationList,
}: Props) {
  const open = () => {
    setView('navi');
  };

  const close = () => {
    setView('default');
  };

  return (
    <>
      <div className={styles.wrapper}>
        {view === 'navi' ? (
          <HamburgerMenuCloseIcon className={styles.icon} onClick={close} />
        ) : (
          <HamburgerMenuIcon className={styles.icon} onClick={open} />
        )}
      </div>

      {/* view が 'navi' の時、ナビ画面を表示する */}
      {view === 'navi' && (
        <nav className={styles.naviScreen}>
          <ViewStyle viewStyle={viewStyle} setViewStyle={setViewStyle} />
          <DrawerMenu informationList={informationList} />
        </nav>
      )}
    </>
  );
}
